import { AppSkeleton } from "../../../../../shared/components/AppSkeleton";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const SkeletonPreview = ({ className }: Props) => {
  return (
    <div className={styles["skeleton-container"]}>
      <AppSkeleton
        variant="rectangular"
        height={52}
        className={styles["skeleton-header"]}
      />
      <div className={styles["skeleton-content"]}>
        <AppSkeleton
          variant="rectangular"
          animation={"wave"}
          className={styles["skeleton-box"]}
        />
      </div>
    </div>
  );
};
